import { fetchOrReportFailure } from '../utilities/network-failure';
import isTokenExpired from './token-validation';

const getToken = (): string => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('jwt token required');
  if (isTokenExpired(token)) throw new Error('token expired');
  return token;
};

const fetchWithToken = (url: string, options: RequestInit) => {
  let authHeaders = {};
  if (localStorage.getItem('token')) {
    authHeaders = {
      authorization: `Bearer ${getToken()}`,
    };
  }
  return fetchOrReportFailure(url, {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
      ...authHeaders,
    },
  });
};

const fetchUnauthed = (url: string, options: RequestInit) =>
  fetchOrReportFailure(url, {
    ...options,
    headers: {
      ...options.headers,
    },
  });

export { fetchUnauthed, fetchWithToken };
